import { FC } from "react";
import {
    Flex,
    Icon,
    LogoIcon,
    CrossOutlineIcon,
    LogoTeensIcon,
} from "@smile2impress/components";
import { useColorMode } from "@smile2impress/themes";

import LogoImpressDrSmileIcon from "components/Icons/icons/logo-impress-drsmile.svg";
import { LogoTheme } from "constants/enum";

import { LogoProps, LogoColorTheme } from "./Logo.types";

export const Logo: FC<LogoProps> = ({
    logoTheme = LogoTheme.BICOLOR,
    logoColorTheme = LogoColorTheme.BASE_LOGO,
    isTeens,
    hasMainLogo = true,
    specialAdditionalLogo = null,
    hasAdditionalLogo = true,
    isRelaunch = false,
    isDRS = false,
}) => {
    let additionLogo;
    let crossIcon;

    if (hasMainLogo && hasAdditionalLogo) {
        crossIcon = (
            <Icon
                as={CrossOutlineIcon}
                color="text.tertiary"
                width={2}
                height={2}
                mx={1}
            />
        );
    }

    if (hasMainLogo && specialAdditionalLogo) {
        crossIcon = (
            <Flex
                height="36px"
                width="1px"
                mx={2}
                backgroundColor="text.disabled"
            />
        );
    }

    if (isTeens) {
        additionLogo = <Icon as={LogoTeensIcon} w="103px" h="32px" />;
    }

    if (specialAdditionalLogo) {
        additionLogo = (
            <>
                {crossIcon}
                {specialAdditionalLogo}
            </>
        );
    }

    const logo = (
        <Icon
            as={isDRS ? LogoImpressDrSmileIcon : LogoIcon}
            width={isRelaunch ? [5, 5, 6] : [17.5, "147px"]}
            height={isRelaunch ? ["28px", "28px", 4] : "auto"}
            mono={logoTheme !== LogoTheme.BICOLOR}
            {...(!isDRS && { color: logoColorTheme })}
        />
    );

    const { colorMode } = useColorMode();

    return (
        <Flex
            alignItems="center"
            width="100%"
            as="span"
            sx={
                colorMode === "dark"
                    ? {
                          "path[fill='#012DF3']": {
                              fill: "#FFFFFF !important",
                          },
                      }
                    : {}
            }
        >
            {hasMainLogo && logo}
            {hasAdditionalLogo && additionLogo}
        </Flex>
    );
};
